import { ICertifiedDocument } from "@components/CertifiedDocuments";
import { create } from "zustand";

export interface IPostHiringStoreState {
  selectedCertificate: ICertifiedDocument | null;
}

interface IPostHiringStoreAction {
  setSelectedCertificate: (selectedCertificate: ICertifiedDocument | null) => void;
}

type TPostHiringStore = IPostHiringStoreAction & IPostHiringStoreState;

const initialState: IPostHiringStoreState = {
  selectedCertificate: null,
};

export const usePostHiringStore = create<TPostHiringStore>((set) => ({
  ...initialState,
  setSelectedCertificate: (selectedCertificate) => {
    set({ selectedCertificate });
  },
}));
